import React from "react";
import Card from "../card/card";
import Loader from "../loader/loader";
import c from "./cards.module.css";

export default function Cards({ currentGame, carga }) {
  if (carga) {
    return <Loader />;
  }

  if (currentGame.length === 0) {
    return (
      <div className={c.contError}>
        <div className={c.errorBK}>
          <div className={c.centerHW}></div>
        </div>
      </div>
    );
  }

  return (
    <div className={c.cards}>
      <div className={`${c.row} ${c.boxWrap}`}>
        {currentGame &&
          currentGame.length &&
          currentGame.map((game) => (
            <Card
              key={game.id}
              id={game.id}
              name={game.name}
              rating={game.rating}
              image={game.image}
              genres={game.genres}
              description={game.description}
            />
          ))}
      </div>
    </div>
  );
}
